(function () {
  'use strict';

  var ALLOWED_TAGS = new Set(['A', 'B', 'BR', 'EM', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'I', 'LI', 'OL', 'P', 'SPAN', 'STRONG', 'U', 'UL']);
  var ALLOWED_ATTRS = new Set(['href', 'target', 'rel', 'title']);
  var SECTION_SELECTORS = {
    title: ['.exseed-pdp-shell__title'],
    intro_text: ['.exseed-pdp-shell__intro'],
    reviews_label: ['.exseed-pdp-shell__stars > span'],
    reviews_subtext: ['.exseed-pdp-shell__reviews-sub'],
    variant_label: ['[data-dynamic-variant-label]'],
    only_label: ['[data-dynamic-only-label]'],
    per_test_suffix: ['[data-dynamic-per-test-suffix]'],
    one_time_purchase_label: ['[data-dynamic-one-time-label]'],
    subscription_heading: ['[data-dynamic-subscription-heading]'],
    subscription_intro: ['[data-subscription-intro]'],
    subscription_usp_1: ['[data-dynamic-subscription-usp="1"] [data-dynamic-copy]'],
    subscription_usp_2: ['[data-dynamic-subscription-usp="2"] [data-dynamic-copy]'],
    subscription_usp_3: ['[data-dynamic-subscription-usp="3"] [data-dynamic-copy]'],
    subscription_usp_4: ['[data-dynamic-subscription-usp="4"] [data-dynamic-copy]'],
    subscription_footer: ['[data-dynamic-subscription-footer]'],
    add_to_cart_text: ['[data-add-to-cart-label]'],
    sold_out_text: ['[data-add-to-cart-label][data-sold-out]']
  };
  var STYLE_PROPERTIES = {
    shell_bg_mobile: '--shell-bg-mobile', shell_bg_desktop: '--shell-bg-desktop',
    hero_card_bg: '--hero-card-bg', text_color: '--text-color', muted_color: '--muted-color',
    heading_color: '--heading-color', border_color: '--border-color', active_color: '--active-color',
    active_text_color: '--active-text-color', save_bg: '--save-bg', save_text: '--save-text',
    button_bg: '--button-bg', button_text: '--button-text', media_radius: '--media-radius',
    panel_radius: '--panel-radius', button_radius: '--button-radius', desktop_gap: '--desktop-gap',
    heading_size_mobile: '--heading-size-mobile', heading_size_desktop: '--heading-size-desktop',
    body_size_mobile: '--body-size-mobile', body_size_desktop: '--body-size-desktop',
    label_size_mobile: '--label-size-mobile', label_size_desktop: '--label-size-desktop',
    price_size_mobile: '--price-size-mobile', price_size_desktop: '--price-size-desktop',
    heading_weight: '--heading-weight', body_weight: '--body-weight', button_weight: '--button-weight'
  };

  function normalise(value) {
    return String(value == null ? '' : value).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function safeUrl(value) {
    var url = String(value || '').trim();
    if (!url) return '';
    if (/^(https?:|mailto:|tel:|\/|#)/i.test(url)) return url;
    return '';
  }

  function sanitiseHtml(html) {
    var parsed = new DOMParser().parseFromString('<div>' + String(html || '') + '</div>', 'text/html');
    Array.prototype.slice.call(parsed.body.querySelectorAll('*')).forEach(function (node) {
      if (!ALLOWED_TAGS.has(node.tagName)) {
        node.replaceWith(document.createTextNode(node.textContent || ''));
        return;
      }
      Array.prototype.slice.call(node.attributes).forEach(function (attribute) {
        if (!ALLOWED_ATTRS.has(attribute.name.toLowerCase())) node.removeAttribute(attribute.name);
      });
      if (node.tagName === 'A') {
        var href = safeUrl(node.getAttribute('href'));
        if (href) node.setAttribute('href', href); else node.removeAttribute('href');
        if (node.getAttribute('target') === '_blank') node.setAttribute('rel', 'noopener noreferrer');
      }
    });
    return parsed.body.firstElementChild.innerHTML;
  }

  function setNodeValue(node, override) {
    if (!node || !override || override.value == null) return;
    if (typeof override.value === 'string' && override.value.trim() === '') return;
    if (override.type === 'richtext') node.innerHTML = sanitiseHtml(override.value);
    else node.textContent = String(override.value);
  }

  function findTextElement(root, original) {
    var wanted = normalise(original);
    if (!wanted) return null;
    var nodes = root.querySelectorAll('p,h1,h2,h3,h4,h5,h6,span,li,a,button,summary,div');
    for (var i = 0; i < nodes.length; i += 1) {
      if (normalise(nodes[i].textContent) === wanted && !nodes[i].querySelector('p,h1,h2,h3,h4,h5,h6,li')) return nodes[i];
    }
    return null;
  }

  function applyGenericSetting(root, settingId, override) {
    if (!override || override.value == null) return;
    var direct = root.querySelector('[data-dlp-setting="' + CSS.escape(settingId) + '"]');
    if (direct) { setNodeValue(direct, override); return; }
    var type = override.type || 'text';
    if (type === 'url' || type === 'video_url') {
      var url = safeUrl(override.value);
      if (!url) return;
      var attr = type === 'video_url' ? 'src' : 'href';
      var candidates = root.querySelectorAll('[' + attr + ']');
      var original = String(override.original || '');
      for (var i = 0; i < candidates.length; i += 1) {
        if (!original || candidates[i].getAttribute(attr) === original) {
          candidates[i].setAttribute(attr, url);
          if (type === 'video_url' && candidates[i].load) candidates[i].load();
          return;
        }
      }
      return;
    }
    if (type === 'image_picker') {
      var images = root.querySelectorAll('img');
      var image = images[Math.max(0, Number(override.imageIndex || 0))];
      var imageUrl = safeUrl(override.value && override.value.url ? override.value.url : override.value);
      if (image && imageUrl) {
        image.src = imageUrl;
        image.removeAttribute('srcset');
        if (override.alt) image.alt = override.alt;
      }
      return;
    }
    var match = findTextElement(root, override.original);
    if (match) setNodeValue(match, override);
  }

  function applyBlockControl(target, settingId, override) {
    if (!override || override.type !== 'checkbox') return false;
    var enabled = Boolean(override.value);
    var rules = {
      enable_mobile_background: ['--block-mobile-bg', enabled ? '' : 'transparent'],
      enable_mobile_border: ['--block-mobile-border-width', enabled ? '1px' : '0px'],
      enable_desktop_background: ['--block-desktop-bg', enabled ? '' : 'transparent'],
      enable_desktop_border: ['--block-desktop-border-width', enabled ? '1px' : '0px'],
      svg_cut_after_enable_mobile: ['--svg-cut-after-mobile-display', enabled ? 'block' : 'none'],
      svg_cut_after_enable_desktop: ['--svg-cut-after-desktop-display', enabled ? 'block' : 'none']
    };
    if (!rules[settingId]) return false;
    if (rules[settingId][1] === '') target.style.removeProperty(rules[settingId][0]);
    else target.style.setProperty(rules[settingId][0], rules[settingId][1]);
    return true;
  }

  function applySection(shell, section) {
    if (!section) return;
    Object.keys(section.styles || {}).forEach(function (key) {
      var property = STYLE_PROPERTIES[key] || (key.indexOf('--') === 0 ? key : '');
      var value = section.styles[key];
      if (property && value !== '') {
        if (/(_radius|_size_|_gap|padding|spacing)/.test(key) && /^\d+(\.\d+)?$/.test(String(value))) value += 'px';
        shell.style.setProperty(property, String(value));
      }
    });
    Object.keys(section.settings || {}).forEach(function (key) {
      var override = section.settings[key];
      var selectors = SECTION_SELECTORS[key];
      if (selectors) selectors.forEach(function (selector) {
        shell.querySelectorAll(selector).forEach(function (node) { setNodeValue(node, override); });
      });
    });
    var image = window.matchMedia('(max-width: 749px)').matches && section.mobileImage ? section.mobileImage : section.image;
    if (image && image.url) {
      var mainImage = shell.querySelector('[data-carousel-track] .exseed-pdp-shell__slide:first-child img');
      if (mainImage) {
        mainImage.src = safeUrl(image.url) || mainImage.src;
        mainImage.removeAttribute('srcset');
        if (image.alt) mainImage.alt = image.alt;
      }
    }
  }

  function applyBlocks(shell, blocks, section) {
    section = section || {};
    Object.keys(blocks || {}).forEach(function (blockId) {
      var override = blocks[blockId] || {};
      var block = shell.querySelector('[data-dlp-block-id="' + CSS.escape(blockId) + '"]');
      if (!block) return;
      if (!block.firstElementChild) block = shell.querySelector('[data-dlp-child-block-id="' + CSS.escape(blockId) + '"]') || block;
      var styleTarget = block.firstElementChild || block;
      if (override.visible === false) { block.hidden = true; return; }
      block.hidden = false;
      if (override.order != null) block.style.order = String(override.order);
      Object.keys(override.settings || {}).forEach(function (settingId) {
        if (!applyBlockControl(styleTarget, settingId, override.settings[settingId])) applyGenericSetting(block, settingId, override.settings[settingId]);
      });
      Object.keys(override.styles || {}).forEach(function (property) {
        if (/^--[a-z0-9-]+$/i.test(property)) {
          if (override.styles[property] === '') styleTarget.style.removeProperty(property);
          else styleTarget.style.setProperty(property, String(override.styles[property]));
      }
    });
    var benefits = [1, 2, 3, 4].map(function (number) {
      return section.settings && section.settings['benefit_' + number] && section.settings['benefit_' + number].value;
    }).filter(function (value) { return value != null && String(value).trim() !== ''; });
    if (benefits.length) shell.querySelectorAll('[data-selected-features]').forEach(function (container) {
      var rows = container.querySelectorAll('.exseed-pdp-shell__feature');
      benefits.forEach(function (benefit, index) {
        var row = rows[index];
        if (!row && rows[0]) { row = rows[0].cloneNode(true); container.appendChild(row); }
        var copy = row && row.querySelector('span:last-child');
        if (copy) copy.textContent = benefit;
      });
      container.classList.remove('is-hidden');
    });
    });
  }

  function init(config) {
    if (!config || config.dataset.initialised === 'true') return;
    config.dataset.initialised = 'true';
    var payload;
    try { payload = JSON.parse(config.textContent || 'null'); } catch (error) { return; }
    if (typeof payload === 'string') { try { payload = JSON.parse(payload); } catch (error) { return; } }
    if (!payload || !Array.isArray(payload.campaigns)) return;
    var parameter = config.getAttribute('data-parameter') || 'campaign';
    var slug = (new URLSearchParams(window.location.search).get(parameter) || '').trim().toLowerCase();
    if (!/^[a-z0-9][a-z0-9_-]{0,63}$/.test(slug)) return;
    var campaign = payload.campaigns.find(function (item) { return item && item.enabled !== false && item.slug === slug; });
    if (!campaign) return;
    var sectionId = config.id.replace('ExseedDynamicPDPConfig-', '');
    var shell = document.getElementById('ExseedPDPShell-' + sectionId);
    if (!shell) return;
    shell.setAttribute('data-active-campaign', slug);
    applySection(shell, campaign.section);
    applyBlocks(shell, campaign.blocks, campaign.section);
    shell.querySelectorAll('product-form').forEach(function (form) {
      var cta = campaign.section && campaign.section.settings && campaign.section.settings.add_to_cart_text;
      if (cta && cta.value) form.setAttribute('data-add-to-cart-text', cta.value);
    });
  }

  document.querySelectorAll('[data-exseed-dynamic-pdp-config]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    var config = event.target && event.target.querySelector('[data-exseed-dynamic-pdp-config]');
    if (config) init(config);
  });
})();
